<template>
    <span :class="color_class">{{ number }}</span>
</template>

<script>
    export default {
        name: "ColorNumber",
        props: ['number'],
        computed: {
            color_class() {
                if (parseFloat(this.number) > 0) {
                    return 'text-success'
                } else {
                    return 'text-danger'
                }
            }
        },
    }
</script>

<style scoped>

</style>